import React from 'react';

import './ForgottenContent.css';

export default ({ onSubmit, onChangeEmail, email }) => (
  <div className="forgotten">
    <h4>Forgotten</h4>
    <form onSubmit={onSubmit}>
      <label>
          Email:
          <input type='email' value={email} onChange={onChangeEmail} />
      </label>
      <input type="submit" value="Submit" />
    </form>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/ForgottenModal/ForgottenContent.jsx